import React, { useCallback } from "react";
import { Typography } from "@mui/material";

import { colors } from "../../theme/palette";

import { CompareList } from "../../types";

import CompareRowText from "./CompareRowText";
import CompareRowFlag from "./CompareRowFlag";
import CompareRowBoolean from "./CompareRowBoolean";
import { useTranslation } from "react-i18next";

const OtherCompare = React.memo(({ compareUsersList }: { compareUsersList: any }) => {
  const { t } = useTranslation();

  const otherOverViewList: CompareList[] = [
    { label: t("components.compare.positionIndustryRole"), key: "subRole", type: "text" },
    { label: t("components.compare.experienceRange"), key: "experienceRange", type: "text" },
  ];

  const nationalityAndLocationList: CompareList[] = [
    { label: t("components.compare.nationality"), key: "nationality", type: "flag" },
    { label: t("components.compare.country"), key: "country", type: "flag" },
  ];

  const professionalInfoList: CompareList[] = [
    { label: t("components.compare.hasFootballExperience"), key: "hasFootballExperience", type: "boolean" },
    { label: t("components.compare.hasCertificate"), key: "hasCertificate", type: "boolean" },
  ];
  const renderCompareRow = useCallback((item: CompareList, index: number, list: CompareList[]) => {
    const { label, key, type } = item;
    const totalRows: number = list.length;
    const isLastRow: boolean = index + 1 === totalRows;

    switch (type) {
      case "text":
        return <CompareRowText compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "flag":
        return <CompareRowFlag compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "boolean":
        return (
          <CompareRowBoolean compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />
        );
      default:
        return null;
    }
  }, []);

  return (
    <>
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.otherOverview")}
      </Typography>
      {otherOverViewList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.nationalityAndLocation")}
      </Typography>
      {nationalityAndLocationList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.professionalInfo")}
      </Typography>
      {professionalInfoList.map(renderCompareRow)}
    </>
  );
});

export default OtherCompare;
